import React from 'react';
import ReactDOM,{Root} from 'react-dom/client';
import {RecoilRoot} from 'recoil';
import './styles';
import App from './App';
import reportWebVitals from './reportWebVitals';


import UserContextProvider from 'context/userContext';

const root:Root=ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);
root.render(
	<React.StrictMode>
		<UserContextProvider>
			<RecoilRoot>
				<App/>
			</RecoilRoot>
		</UserContextProvider>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
